<template>
  <div id="app">
    <Header @openForm="showModal = true" />
    <main>
      <router-view />
      <modal @close="showModal = false" v-show="showModal">
        <template v-slot:body>
          <iframe
            src="https://ulbrex.hypnobox.com.br/?controle=Atendimento&acao=index&produto=33&midia=undefined_undefined_undefined"
            style="width: 100%; height: 470px;"
          ></iframe>
        </template>
      </modal>
    </main>
    <cookie-law
      button-text="Aceitar"
      :button-decline="true"
      button-decline-text="Recusar"
    >
      <div slot="message">
        A Ulbrex, através do Portal DezNoventa, está comprometida com a proteção
        da privacidade e dos dados pessoais dos seus clientes, parceiros e
        outros interessados. Por isso, apresenta este Aviso de Privacidade
        (“Aviso”) a fim de informar aos titulares sobre o tratamento de seus
        dados pessoais pela empresa, inclusive aqueles coletados mediante o uso
        de cookies.

        <router-link class="terms-button" :to="{ name: 'TermsOfUse' }" exact>
          Ler a política de privacidade.
        </router-link>
      </div>
    </cookie-law>
    <Footer />
    <WhatsAppButton />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import Modal from '@/components/shared/Modal.vue';
import { leadsService } from '@/services/leads.service';
import CookieLaw from 'vue-cookie-law';
import WhatsAppButton from '@/components/WhatsAppButton.vue'; // Importe o componente

export default {
  name: 'App',

  components: {
    Footer,
    Header,
    Modal,
    CookieLaw,
    WhatsAppButton, // Registre o componente
  },

  data() {
    return {
      showModal: false,
      lead: {},
      successLead: false,
    };
  },

  mounted() {},

  computed: {
    disabledButton() {
      return this.lead.name && this.lead.email && this.lead.phone_number;
    },
  },

  methods: {
    async createLead() {
      const payload = {
        name: this.lead.name,
        phone_number: this.lead.phone_number,
        email: this.lead.email,
      };
      try {
        await leadsService.create(payload);
        this.sucessLead = true;
        this.lead = {};
      } catch (error) {
        console.log('Ocorreu um erro inesperado.');
      }
    },

    goToTerms() {
      this.showModal = false;
      this.$router.push({ path: 'terms' });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/styleguide';
@import '@/assets/css/buttons';
@import '@/assets/css/base';

* {
  margin: 0;
  padding: 0;
  outline: none;
  box-sizing: border-box;
}

html,
body {
  scroll-behavior: smooth;
  width: 100%;
  height: 100%;
  margin: 0px;
  overflow-x: hidden;
}

#app {
  background: var(--white);
  font-family: var(--font-primary);
  font-weight: 300;
  font-size: var(--size-large);
  line-height: 29px;
  color: var(--atomic);
}

.terms-button {
  color: #3c89cd;
  text-decoration: none;
}

.post-content {
  margin: 0 0 24px;
  padding: 0 0 0 105px;
  max-width: 1000px;

  p {
    font-weight: 300;
    line-height: 29px;
    margin: 0 0 24px;
    font-size: var(--size-large);
    color: var(--atomic);
    a {
      text-decoration: none;
      color: var(--blue-custom);
      font-weight: 700;
    }
  }

  h1 {
    font-size: 32px;
    margin: 0 0 24px;
  }

  h2 {
    margin: 24px 0 24px;
    padding: 0 0 0 0;
    line-height: 36px;
    font-weight: 700;
    font-size: var(--size-subtitle-post);
    color: var(--secundary-black);
  }

  h3 {
    margin-bottom: 16px;
    font-weight: 700;
    margin: 0 0 24px;
    line-height: 29px;
    font-size: var(--size-large);
    color: var(--atomic);
  }

  p,
  ul,
  li,
  ol {
    font-size: var(--size-large);
    color: var(--atomic);
  }

  ul {
    margin-left: 20px;
    list-style-position: outside;
    list-style: disc;
  }

  ol {
    margin-left: 20px;
    list-style-position: outside;
    list-style: decimal;
  }

  blockquote {
    border-left: 3px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.8);
    padding-left: 0.8rem;
    font-style: italic;
  }
}

@media screen and (max-width: 768px) {
  .modal-policy {
    display: block;
  }
}
</style>
